"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const form_1 = require("../../atoms/form");
exports.default = (props) => {
    return ((0, jsx_runtime_1.jsx)(Wrapper, { children: props.coachingDays.map((selectValue, selectIndex) => {
            const onChange = (e) => props.onChange(selectIndex)(parseInt(e.target.value));
            return ((0, jsx_runtime_1.jsx)(form_1.Select, { "data-cy": `coaching-day-select-${selectIndex}`, onChange: onChange, disabled: props.offline, value: props.days.indexOf(selectValue) + "", children: props.days.map((day, index) => {
                    const isDisabled = props.coachingDays.includes(day);
                    return ((0, jsx_runtime_1.jsx)("option", { "data-cy": `coaching-day-option${isDisabled ? "-disabled" : ""}`, value: index, disabled: isDisabled && day !== selectValue, children: day }, day));
                }) }, selectValue));
        }) }, void 0));
};
const Wrapper = styled_components_1.default.div `
  display: flex;

  & > div {
    flex: 1;
  }

  & > div:nth-of-type(2) {
    margin-left: ${({ theme }) => theme.spacings.xs};
    margin-right: ${({ theme }) => theme.spacings.xs};
  }

  select {
    color: ${({ theme }) => theme.colors.greyBase};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    flex-direction: column;

    & > div:not(:last-of-type) {
      margin: ${({ theme }) => `0 0 ${theme.spacings.xs}`};
    }
  }
`;
//# sourceMappingURL=RegularSelects.js.map